import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_LEGAJOS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(id) {
  return wsService.make_get_request(section + "/get/" + id);
}

function delete_folder(param = {}) {
  return wsService.make_delete_request(section + "/delete-folder", param);
}

function update_folder(param = {}) {
  return wsService.make_put_request(section + "/update-folder", param);
}

function create_folder(param = {}) {
  return wsService.make_post_request(section + "/create-folder", param);
}

function get_next_nro_legajo() {
  return wsService.make_post_request(section + "/get_next_nro_legajo");
}

// Acceso del empleado al sistema. param: { id, password }
function create_access(param = {}) {
  return wsService.make_post_request(section + "/create-access", param);
}

// param: { id, password } - nueva contraseña temporal
function reset_access_password(param = {}) {
  return wsService.make_post_request(section + "/reset-access-password", param);
}

// param: { id }
function disable_access(param = {}) {
  return wsService.make_post_request(section + "/disable-access", param);
}

// param: { id }
function enable_access(param = {}) {
  return wsService.make_post_request(section + "/enable-access", param);
}

export const legajoService = {
  section,
  filter,
  remove,
  create,
  update,
  get,
  update_folder,
  delete_folder,
  create_folder,
  get_next_nro_legajo,
  create_access,
  reset_access_password,
  disable_access,
  enable_access,
};
